import React, { FC } from "react";

interface CustomModalProps {
  isVisible: boolean;
  title: string;
  onClose: () => void;
  footer: React.ReactNode;
  children: React.ReactNode;
  width: string;
  height?: string;
}

const CustomModal: FC<CustomModalProps> = ({
  isVisible,
  title,
  onClose,
  footer,
  children,
  width,
  height = "784px",
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black opacity-50" onClick={onClose} />

      {/* Modal */}
      <div
        className={`${width} z-10 rounded-xl overflow-hidden shadow-2xl flex flex-col`}
        style={{
          background: "#DFE8F5",
          maxHeight: height,
          minHeight: "389px",
        }}
      >
        {/* Header */}
        <div
          className="px-6 flex items-center"
          style={{
            background: "#3478F6",
            minHeight: "56px",
          }}
        >
          <h2
            className="font-semibold"
            style={{
              color: "#fff",
              fontSize: "20px",
              lineHeight: 1,
              margin: 0,
            }}
          >
            {title}
          </h2>
        </div>

        {/* Body */}
        <div
          className="flex-1 overflow-y-auto"
          style={{
            background: "#DFE8F5",
            padding: "40px 32px 24px",
          }}
        >
          {children}
        </div>

        {/* Footer */}
        <div
          className="flex items-center justify-between"
          style={{
            background: "#DFE8F5",
            padding: "24px 32px 32px",
          }}
        >
          {footer}
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
